import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconMenuOpen.tsx
const OutlinedFilledMenuOpen = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M95-215v-93h530v93H95Zm705-55L596-481l203-210 67 67-138 143 139 144-67 67ZM95-435v-94h416v94H95Zm0-217v-94h530v94H95Z" })
});
const OutlinedMenuOpen = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M95-215v-93h530v93H95Zm705-55L596-481l203-210 67 67-138 143 139 144-67 67ZM95-435v-94h416v94H95Zm0-217v-94h530v94H95Z" })
});
const RoundedFilledMenuOpen = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M141-215q-20.1 0-33.05-13.68Q95-242.35 95-262.42t12.95-32.83Q120.9-308 141-308h438q19.1 0 32.55 13.68Q625-280.65 625-260.58t-12.95 32.83Q599.1-215 579-215H141Zm627-90L627-448q-14-14-14-33t14-33l139-143q14-15 33.5-15t34.5 15q14 14 14 32.5T835-592L728-481l108 112q13 14 12.5 32.5T834-304q-14 14-33 14t-33-15ZM141-435q-20.1 0-33.05-13.68Q95-462.35 95-482.42t12.95-33.33Q120.9-529 141-529h324q19.1 0 32.55 14.18Q511-500.65 511-480.58t-12.95 32.83Q485.1-435 465-435H141Zm0-217q-20.1 0-33.05-13.68Q95-679.35 95-699.42t12.95-33.33Q120.9-746 141-746h438q19.1 0 32.55 14.18Q625-717.65 625-697.58t-12.95 32.83Q599.1-652 579-652H141Z" })
});
const RoundedMenuOpen = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M141-215q-20.1 0-33.05-13.68Q95-242.35 95-262.42t12.95-32.83Q120.9-308 141-308h438q19.1 0 32.55 13.68Q625-280.65 625-260.58t-12.95 32.83Q599.1-215 579-215H141Zm627-90L627-448q-14-14-14-33t14-33l139-143q14-15 33.5-15t34.5 15q14 14 14 32.5T835-592L728-481l108 112q13 14 12.5 32.5T834-304q-14 14-33 14t-33-15ZM141-435q-20.1 0-33.05-13.68Q95-462.35 95-482.42t12.95-33.33Q120.9-529 141-529h324q19.1 0 32.55 14.18Q511-500.65 511-480.58t-12.95 32.83Q485.1-435 465-435H141Zm0-217q-20.1 0-33.05-13.68Q95-679.35 95-699.42t12.95-33.33Q120.9-746 141-746h438q19.1 0 32.55 14.18Q625-717.65 625-697.58t-12.95 32.83Q599.1-652 579-652H141Z" })
});
const SharpFilledMenuOpen = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M95-215v-93h530v93H95Zm705-55L596-481l203-210 67 67-138 143 139 144-67 67ZM95-435v-94h416v94H95Zm0-217v-94h530v94H95Z" })
});
const SharpMenuOpen = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M95-215v-93h530v93H95Zm705-55L596-481l203-210 67 67-138 143 139 144-67 67ZM95-435v-94h416v94H95Zm0-217v-94h530v94H95Z" })
});
const componentMap = {
	outlined: OutlinedMenuOpen,
	"outlined-fill": OutlinedFilledMenuOpen,
	rounded: RoundedMenuOpen,
	"rounded-fill": RoundedFilledMenuOpen,
	sharp: SharpMenuOpen,
	"sharp-fill": SharpFilledMenuOpen
};
const IconMenuOpen = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconMenuOpen };